module.exports = __webpack_public_path__ + "static/media/Al-Futtaim_.dcbbd809.jpg";